import React from "react";
import { CardData } from "@/components/layout/element-layout/grid-layout/GridLayout";
import { GlossaryBlueprint } from "@/types-games";
import { deleteTemplate } from "@/lib/stores/templatesStore";
import GlossaryWidget from       "@/components/cards/widgets/ObjectsWidget";
import EditBlueprintWizardCompact from "@/components/wizards/blueprints/blueprint_wizard/EditBlueprintWizard";
import { Version } from "@/lib/stores/storeTypes";
import { ItemTypeConfig } from "./types";
import { templatesDataSource } from "@/lib/dataSources/sources/templates";

export const blueprintsConfig: ItemTypeConfig = {
  type: "blueprints",
  title: "Templates",
  pageSection: "blueprints",
  eventName: "addTemplate",
  emptyStateTitle: "No Templates",
  emptyStateDescription:
    "No templates found for this game. Create your first template to get started.",
  noGameSelectedDescription: "Please select a game to view its templates.",
  
  /**
   * Transform raw items to CardData using the DataSource transformer
   * This delegates to templatesDataSource.transformers.toCard() for single source of truth
   */
  transformData: (
    blueprints: GlossaryBlueprint[],
    tags: any[],
    getUserNameById: (id: string) => string
  ): CardData[] => {
    if (!blueprints || !Array.isArray(blueprints)) {
      console.warn("transformData: blueprints is not an array:", blueprints);
      return [];
    }
    
    // Use DataSource transformer with context
    return templatesDataSource.transformers.toCard?.(blueprints, {
      tags,
      getUserNameById,
    }) || [];
  },

  renderCard: (card: CardData, tags: any[]) => {
    return (
      <GlossaryWidget
        id={card.id}
        gameId={card.gameId}
        title={card.title}
        tags={card.tags}
        description={card.description}
        lastUpdate={card.lastUpdate}
        version={card.version as number | Version}
        status={card.status}
        folder={card.folder as string}
        itemType="templates"
        icon={card.icon}
        iconBg={card.iconBg}
        shadowType={card.shadowType}
        shadowColor={card.shadowColor}
        hasVersionMismatch={card.hasVersionMismatch}
        owner={card.owner}
        onDelete={card.onDelete}
        onEdit={card.onEdit}
      />
    );
  },

  getWizard: (props: any) => <EditBlueprintWizardCompact {...props} />,

  handleDelete: async (id: string, gameId: string, toast: any) => {
    await deleteTemplate(id, gameId, toast);
    toast({
      title: "Success",
      description: "Template deleted successfully",
    });
  },

  handleCardClick: (card: CardData) => {
    // Navigation handled by hook
  },

  handleAdd: () => {
    // Handled by hook
  },
};

